<template>
  <div class="adurl">
    <div class="title">
      <van-nav-bar
        title="荷叶健康"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <iframe :src="$route.query.url" />
  </div>
</template>
<script>

export default {
  methods: {
    onClickLeft () {
      this.$router.back(-1)
    }
  }
}
</script>
<style scoped>
#app {
  height: 100vh;
}
.title {
  height: 64px;
}
.adurl /deep/.van-nav-bar {
  height: 64px;
  line-height: 64px;
}
.adurl .van-hairline--bottom::after {
  border: none;
}
.adurl {
  width: 375px;
  height: 100vh;
  background: #fff;
  position: relative;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  display: flex;
  flex-direction: column;
}
iframe {
  flex: 1;
  border: 0;
}
</style>
